import React from "react";
import { Platform } from "react-native";
import { ModalNative } from "./modal-native";
import { ModalWeb } from "./modal-web";
export const IsInModalCtx = React.createContext(false);
export function useIsInModal() {
    return React.useContext(IsInModalCtx);
}
export const Modal = Platform.OS === "web" ? ModalWeb : ModalNative;
